import styled from 'styled-components';

export const HeaderElem = styled.header`
  ${({ theme }) => `
    display: flex;
    margin: 0 0 ${theme.layout.spacing.centy};
    align-items: center;
    justify-content: space-between;
    gap: ${theme.layout.spacing.centy};

    @media ${theme.layout.breakpoints.max.tablet} {
      flex-flow: column nowrap;
      flex-flow: row nowrap;
      gap: ${theme.layout.spacing.mikro};
    }
  `};
`;
